export default "__VITE_ASSET__BiI$jJ8V__"